module.exports = __webpack_public_path__ + "static/media/8-hybrid.d817a3d9.png";